/**
 * CXOne OAuth Configuration Constants
 */

export const CXONE_CONFIG = {
  CLIENT_ID: process.env.VUE_APP_CXONE_CLIENT_ID || 'a9496592-61de-4190-8c6c-a47c711369b2',
  AUTH_URL: 'https://cxone.niceincontact.com/auth/authorize',
  TOKEN_URL: 'https://cxone.niceincontact.com/auth/token',
  USERINFO_URL: 'https://cxone.niceincontact.com/auth/userinfo',
  SCOPE: 'openid',
  RESPONSE_TYPE: 'code'
}

export const CXONE_MESSAGE_TYPES = {
  SUCCESS: 'CXOneAuthSuccess',
  ERROR: 'CXOneAuthError'
}

export const CXONE_TIMEOUTS = {
  POPUP_CLOSE_DELAY_MS: 500,
  TOKEN_EXPIRATION_SECONDS: 2400
}

export const POPUP_CONFIG = {
  WIDTH: 600,
  HEIGHT: 700,
  FEATURES: 'width=600,height=700,left=200,top=100,menubar=no,toolbar=no,location=no,status=no'
}

export const CXONE_SKILL_MEDIA_TYPE = {
  EMAIL: 4
}

/** Allowed origins for postMessage from CXOne popup (besides same origin) */
export const CXONE_ALLOWED_MESSAGE_ORIGINS = [
  'knowitsolution.com'
]
